export default __webpack_public_path__ + "static/media/Shadow's Belt of the Burning Temple.27033b20.jpg";